function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 6.233C64.254.55 91.796 9.643 218.834 12.564 315.37 14.785 433.405 0 607.165 0c70.631 0 187.875 13.347 250.471 14.785C962.708 17.199 1024 10.613 1024 10.613V24H0V6.233z",
  fill: "currentColor"
});

function SvgProductStepsTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgdmlld0JveD0iMCAwIDEwMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDYuMjMyODhDNjQuMjUzNyAwLjU0OTY1NyA5MS43OTYxIDkuNjQyMjEgMjE4LjgzNCAxMi41NjQ0QzMxNS4zNyAxNC43ODUgNDMzLjQwNSAwIDYwNy4xNjUgMEM2NzcuNzk2IDAgNzk1LjA0IDEzLjM0NzEgODU3LjYzNiAxNC43ODVDOTYyLjcwOCAxNy4xOTg2IDEwMjQgMTAuNjEzIDEwMjQgMTAuNjEzVjI0SDBWNi4yMzI4OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgProductStepsTop as ReactComponent };